/* eslint-disable import/prefer-default-export */
import {
    convertNullableDateTimeToUkgUserDateTime,
// eslint-disable-next-line import/no-unresolved
} from '@commonClient2/services/ukgDateTime';
import { UkgDateFormat } from '../../../../Enums';
import DateFormatService from '../../../../services/DateFormatService';
import i18n from '../../../../services/i18n';

/**
 * @param {EmployeeBidProfile.IEmployeeBidProfile[]} bidProfiles
 * @returns {EmployeeAssignedShiftline.IEmployeeAssignedShiftline[]}
 */
export const parseAssignedShiftlines = (bidProfiles) => {
    const assignedShiftlines = bidProfiles
        .filter((x) => x.approvedShiftlineInfos !== null)
        .map((x) => {
            // @ts-ignore
            const lockUpdateDateInUkgUserDateTime = convertNullableDateTimeToUkgUserDateTime(x.approvedShiftlineInfos.lockUpdateDate);
            const requestStart = DateFormatService.formatDateOrEmpty(x.requestPeriodStartDate, UkgDateFormat.LongDate);
            const requestEnd = x.isForeverRequestPeriod
                ? i18n.t('shiftBidding:employee.anytime')
                : DateFormatService.formatDateOrEmpty(x.requestPeriodEndDate, UkgDateFormat.LongDate);
            const requestPeriodLabel = `${requestStart} - ${requestEnd}`;
            return {
                sourceProfileId: x.profileId,
                name: x.name,
                // @ts-ignore
                schedule: x.approvedShiftlineInfos.shiftLineName,
                period: requestPeriodLabel,
                // @ts-ignore
                isLocked: x.approvedShiftlineInfos.isLocked,
                // @ts-ignore
                isLockable: x.approvedShiftlineInfos.isLockable,
                lockUpdateDate: lockUpdateDateInUkgUserDateTime,
                lastUpdateString: DateFormatService.formatDateOrEmpty(
                    lockUpdateDateInUkgUserDateTime,
                    UkgDateFormat.LongDateTime,
                ),
                rebidNumber: x.rebidNumber,
            };
        });
    return assignedShiftlines;
};
